export default __webpack_public_path__ + "static/media/user.e737c5b5.svg";